import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { routes } from './routes'
// import store from './store'
import VueScrollTo from "vue-scrollto"

Vue.use(Router)
Vue.use(Meta)

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if(to.hash) {
      VueScrollTo.scrollTo(to.hash, 500, {offset: -50});
      return { selector: to.hash };
    }
    if(savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 }
  },
});